import React from 'react';
import TableRow from './Tablerow';

const PopUpTable = ({ pages = [], loading = false, onDelete }) => {

  if (loading) {
    return (
      <div className="space-y-3 mt-4">
        {[...Array(5)].map((_, index) => (
          <div
            key={index}
            className="h-14 bg-gray-100 rounded-xl animate-pulse"
          />
        ))}
      </div>
    );
  }

  if (pages.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center py-16 text-center">
        <div className="text-7xl mb-6 opacity-70">📄</div>
        <h3 className="text-xl font-semibold text-[#17171C] mb-3">
          No PopUp Found
        </h3>
        <p className="text-[#6F6F7B] max-w-md">
          You haven't created any popups yet. Click "Add New Popup" to get started.
        </p>
      </div>
    );
  }

  // Normal table view (when there are pages and not loading)
  return (
    <div className="overflow-x-auto bg-white">
      <table className="w-full min-w-[900px]">
        <thead>
          <tr className="h-12 border border-[#E4E4E7]">
            <th className="text-left py-4 px-6 text-xs font-semibold text-[#6F6F7B] uppercase tracking-wider">
              ID
            </th>
            <th className="text-left py-4 px-6 text-xs font-semibold text-[#6F6F7B] uppercase tracking-wider">
              Title
            </th>
            <th className="text-left py-4 px-6 text-xs font-semibold text-[#6F6F7B] uppercase tracking-wider">
              Author
            </th>
            <th className="text-left py-4 px-6 text-xs font-semibold text-[#6F6F7B] uppercase tracking-wider">
              Created At
            </th>
            <th className="text-left py-4 px-6 text-xs font-semibold text-[#6F6F7B] uppercase tracking-wider">
              Shortcode
            </th>
            <th className="text-left py-4 px-6 text-xs font-semibold text-[#6F6F7B] uppercase tracking-wider">
              Actions
            </th>
          </tr>
        </thead>
        <tbody className="divide-y divide-[#E4E4E7]">
          {pages.map((page) => (
            <TableRow key={page.id} page={page} onDelete={onDelete} />
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default PopUpTable;